import { WITHDRAWAL_STATUSES } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(WITHDRAWAL_STATUSES);
    }
}